// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"0":"e2c150aa","861":"e2c150aa"}[chunkId] + ".chunk.css";
};